import Icon from '@/components/Icon'
import Layout, { Stack } from '@/components/Layout'
import Text from '@/components/Text'
import { CtaPageSection } from '@/shared/api-generated-types'
import Link from 'next/link'
import * as styles from './style'

export interface Props extends CtaPageSection {
  className?: string
}

// TODO: url default to '/' is trash fix on api side
const CtaBlock = ({ url = '/', label, className }: Props): JSX.Element => (
  <Link href={url} className={`${styles.root} ${className}`}>
    <Layout>
      <Stack x alignItems="center">
        <Text size="sm" weight="md">
          {label}
        </Text>
        <Icon name="chevron-right" />
      </Stack>
    </Layout>
  </Link>
)
export default CtaBlock
